(() => {
  const arrowTypes = {
    '\u2197': 'ne',
    '\u2192': 'east',
    '\u27F6': 'east',
    '\u279C': 'east',
    '\u2191': 'up',
    '\u2190': 'west',
    '\u27F5': 'west',
    '\u2193': 'down'
  };
  const arrowPattern = /([\u2190\u2191\u2192\u2193\u2197\u279C\u27F5\u27F6])/g;

  const createArrow = (type) => {
    const arrow = document.createElement('span');
    arrow.className = `tpl-ui-arrow tpl-ui-arrow--${type}`;
    arrow.setAttribute('aria-hidden', 'true');
    return arrow;
  };

  const replaceTextNode = (node) => {
    const text = node.nodeValue;
    arrowPattern.lastIndex = 0;
    if (!text || !arrowPattern.test(text)) return;
    arrowPattern.lastIndex = 0;

    const fragment = document.createDocumentFragment();
    let cursor = 0;
    let match;

    while ((match = arrowPattern.exec(text)) !== null) {
      if (match.index > cursor) fragment.append(document.createTextNode(text.slice(cursor, match.index)));
      fragment.append(createArrow(arrowTypes[match[0]]));
      cursor = match.index + match[0].length;
    }

    if (cursor < text.length) fragment.append(document.createTextNode(text.slice(cursor)));
    node.replaceWith(fragment);
  };

  const enhanceArrows = (root) => {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;
    const nodes = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, textarea, input, .tpl-ui-arrow')) return NodeFilter.FILTER_REJECT;
        arrowPattern.lastIndex = 0;
        return arrowPattern.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceTextNode);
  };

  const initialize = () => {
    enhanceArrows(document.body);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) replaceTextNode(node);
          if (node.nodeType === Node.ELEMENT_NODE) enhanceArrows(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
